import React from "react";
import {BaseTitleFragment, BaseTitleFragmentState} from "../BaseTitleFragment";
import {StyledEmpty} from "../../shared/StyledComponents";
import {ChatOutlined} from "@mui/icons-material";
import {LoginSpec, PageFragment} from "../../shared/PageFragment";
import {TabInfo} from "../../shared/TabsContainer";
import {PathComponent} from "../../index";
import {$KTS, KeyTextStrings} from "../../shared/types";


enum MessagesTabsType {
  INBOX = "inbox",
  ARCHIVE = "archive",
}

const MESSAGES_TABS_TYPE_KTS = new KeyTextStrings([
  $KTS(MessagesTabsType.INBOX, "Inbox"),
  $KTS(MessagesTabsType.ARCHIVE, "Archive"),
]);

const TABS: TabInfo<MessagesTabsType>[] = [
  {
    type: MessagesTabsType.INBOX,
    text: "Inbox",
  },
  {
    type: MessagesTabsType.ARCHIVE,
    text: "Archive",
  },
];

export class MessagesFragment extends BaseTitleFragment {

  protected onCreateState(): BaseTitleFragmentState {
    return {
      ...super.onCreateState(),
      selectedToolbarTabId: MessagesTabsType.INBOX,
    };
  }

  protected getTitle(): string {
    return "Messages";
  }

  protected createLoginSpec(): LoginSpec | null {
    return {
      needsLogin: true,
      redirectAfterLoginPath: "/messages",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  getToolbarTabs(): TabInfo<any>[] {
    return TABS;
  }

  protected renderPageContent(): React.ReactElement {
    return <StyledEmpty emptyConfig={{
      title: "No messages found",
      text: "You're all caught up.",
      iconType: ChatOutlined,
    }}/>;
  }
}